import { yupResolver } from "@hookform/resolvers/yup";
import FormInputMenu from "@repo/components/src/forms/menu";
import { Box } from "@repo/components/src/ui/box";
import { Card } from "@repo/components/src/ui/card";
import { HStack } from "@repo/components/src/ui/hstack";
import { Text } from "@repo/components/src/ui/text";
import { formatSeparators } from "@repo/components/src/utils/numbers";
import React from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import SharedTikTokStatistics from "../../shared/tiktok";
import { ProfileBodyProps } from "../../types";

const tiktokSchema = yup.object({
  tiktok: yup.string().required(),
});

type TIkTokSchema = yup.InferType<typeof tiktokSchema>;

const ProfileTikTok = React.memo((props: ProfileBodyProps) => {
  const { user } = props;
  const tiktokSet = user.tiktokSet
    .slice()
    .sort()
    .reverse();
  const formProps = useForm<TIkTokSchema>({
    resolver: yupResolver(tiktokSchema),
    defaultValues: {
      tiktok: tiktokSet.find(() => true)?.id,
    },
  });
  const selectedTikTokId = formProps.watch("tiktok");
  const selectedTikTok = tiktokSet.find(
    (tikTok) => tikTok.id === selectedTikTokId,
  );
  if (!selectedTikTok) {
    const userFields = user;

    return (
      <Text action="muted">
        {userFields.firstName} no tiene una cuenta de TikTok conectada a Montu.
      </Text>
    );
  }
  return (
    <Box>
      {tiktokSet.length > 1 && (
        <Card variant="outline" size="md" className="w-full rounded-xl mb-3">
          <HStack space="sm" className="items-center">
            <Text action="muted">
              Los datos que estás visualizando, corresponden a la siguiente
              cuenta de TikTok:
            </Text>
            <FormInputMenu
              control={formProps.control}
              name="tiktok"
              placeholder="-"
              size="sm"
              buttonTriggerProps={{
                rounded: "lg",
                action: "muted",
                variant: "outline",
                className: "bg-background-50 px-2 h-6",
                size: "sm",
              }}
              headingProps={{
                bold: false,
                size: "xs",
              }}
              options={tiktokSet.map((tiktok) => ({
                label: formatSeparators(tiktok.followers),
                value: tiktok.id,
              }))}
            />
          </HStack>
        </Card>
      )}
      {selectedTikTok.accessTokenStatus ? (
        <SharedTikTokStatistics tikTok={selectedTikTok} />
      ) : (
        <Text action="muted">
          La cuenta de TikTok @{selectedTikTok.username} no está conectada a
          Montu.
        </Text>
      )}
    </Box>
  );
});

ProfileTikTok.displayName = "ProfileTikTok";

export default ProfileTikTok;
